import {
    AccountSettingsApi,
    ActivityTrackerPreferenceApi,
    ClientCompanyAccountManagerApi,
    ClientCompanyLogoApi,
    ClientCompanyPaymentPreferencesApi,
    ClientCompanyProfileApi,
    ClientCompanyProjectSettingsApi,
    ClientCompanyProposalSettingsApi,
    ClientLegalEntityApi,
    ClientLegalEntityUpgradeEligibilityApi,
    ClientSettingsApi,
    ClientTermsAndConditionsApi,
    Configuration,
    IndicesAdminApi,
    ManagerMigrationApi,
    OrganizationDetailsApi,
    OrganizationManagerAdminApi,
    OrganizationMemberDetailsApi,
    OrganizationScimSettingsAdminApi,
    OrganizationSettingsAdminApi,
    OrganizationTeamsApi,
    PlatformSubsidiaryApi,
    PricingPlanApi,
    PublicTeamInvitationApi,
    ServiceLevelAdminApi,
    ServiceLevelApi,
} from '@api';

const configuration = new Configuration({basePath: ''});

export const clientCompanyProfileEndpoints = new ClientCompanyProfileApi(configuration);
export const activityTrackerPreferenceEndpoints = new ActivityTrackerPreferenceApi(configuration);
export const clientCompanyPaymentPreferencesEndpoints = new ClientCompanyPaymentPreferencesApi(configuration);
export const clientCompanyProposalSettingsEndpoints = new ClientCompanyProposalSettingsApi(configuration);
export const clientCompanyProjectSettingsEndpoints = new ClientCompanyProjectSettingsApi(configuration);
export const clientSettingsEndpoints = new ClientSettingsApi(configuration);
export const clientManagerContactEndpoints = new ClientCompanyAccountManagerApi(configuration);
export const clientCompanyLogoEnpoints = new ClientCompanyLogoApi(configuration);
export const serviceLevelAdminEndpoints = new ServiceLevelAdminApi(configuration);
export const pricingPlanEndpoints = new PricingPlanApi(configuration);
export const serviceLevelApiEndPoints = new ServiceLevelApi(configuration);
export const publicTeamInvitationEndpoints = new PublicTeamInvitationApi(configuration);
export const accountSettingsEndPoints = new AccountSettingsApi(configuration);
export const managerEndpoints = new OrganizationManagerAdminApi(configuration);
export const organizationSettingsEndpoints = new OrganizationSettingsAdminApi(configuration);
export const organizationDetailsEndpoints = new OrganizationDetailsApi(configuration);
export const organizationScimSettingsEndpoints = new OrganizationScimSettingsAdminApi(configuration);
export const legalEntityApi = new ClientLegalEntityApi(configuration);
export const upgradeEligibilityApi = new ClientLegalEntityUpgradeEligibilityApi(configuration);
export const clientTermsAndConditionsApi = new ClientTermsAndConditionsApi(configuration);
export const platformSubsidiaryApi = new PlatformSubsidiaryApi(configuration);
export const indicesAdminApi = new IndicesAdminApi(configuration);
export const managerMigrationApi = new ManagerMigrationApi(configuration);
export const organizationMemberDetailsApi = new OrganizationMemberDetailsApi(configuration);
export const organizationTeamsApi = new OrganizationTeamsApi(configuration);
